module.exports = __webpack_public_path__ + "img/beer_id-104.8165db0d.png";